import React from 'react'
import  Dosa  from '../FoodData/Dosa'
import Idly from '../FoodData/Idly'
import  Chap from '../FoodData/Chap'
import  Bonda from '../FoodData/Bonda'
import Puri from '../FoodData/Puri'
import Upma from '../FoodData/Upma'


export const Products = () => {
  return (
    <div>

        <Dosa />
        <Idly />
        <Chap/>
        <Bonda/>
        <Puri/>
        <Upma/>
    </div>
  )
}
